export enum PrimerBreakpoints {
  MobileTable = 719,
}
